import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export type TFactTone = 'default' | 'success' | 'danger' | 'motion' | 'muted';

const TONE: Record<TFactTone, string> = {
  default: 'text-primary',
  success: 'text-success',
  danger: 'text-danger-text',
  motion: 'text-motion',
  muted: 'text-faint',
};

export const FactList = ({
  ruled = true,
  children,
  className,
}: {
  ruled?: boolean;
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex flex-col',
      ruled ? '[&>*]:border-b [&>*]:border-border-row [&>*]:py-2' : 'gap-inset',
      className,
    )}
  >
    {children}
  </div>
);

interface IFactRowProps {
  label: ReactNode;
  tone?: TFactTone;
  mono?: boolean;
  children: ReactNode;
  className?: string;
}

export const FactRow = ({ label, tone = 'default', mono, children, className }: IFactRowProps) => (
  <div className={cn('flex justify-between gap-4 text-meta', className)}>
    <span className="leading-18 text-muted">{label}</span>
    <span className={cn('text-right leading-18', TONE[tone], mono && 'font-mono')}>{children}</span>
  </div>
);
